import(/* webpackMode: "eager" */ "/Users/hosumlai/Documents/projects/ohmyink/ohmyink-artist/src/app/page.tsx");
